<template>
  <div class="powered-by"></div>
</template>

<script>
export default {
  name: 'PoweredBy',
}
</script>

<style scoped>
  .powered-by {
    position: absolute;
    width: 150px;
    height: 38px;
    background-repeat: no-repeat;
    bottom: 2rem;
    right: 2rem;
    background-image: url(~@/assets/themes/master/poweredbyhomesearch.png);
    background-size: contain;
  }
  .powered-by span {
    font-size: 0.7rem;
  }
</style>
